import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
export const config = {
    value: 'tabReload',
    position: ALL_BUTTON_POSITION_LIST,
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindTab } = options;
        function reloadOneTab(id) {
            if (typeof id === 'string') {
                const tab = _context.$(id);
                tab?.getData?.();
            }
        }
        if (_bindTab && _context) {
            if (Array.isArray(_bindTab)) {
                _bindTab.forEach((item) => {
                    reloadOneTab(item);
                });
            }
            else {
                reloadOneTab(_bindTab);
            }
        }
    },
};
